import { render } from "./CguVirtualLaserGame.vue?vue&type=template&id=4de27052&scoped=true"
const script = {}

import "./CguVirtualLaserGame.vue?vue&type=style&index=0&id=4de27052&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de27052"]])

export default __exports__